<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户</label>
            <em class="weui-form-preview__value">{{initData.cu_name}}</em>
          </div>
        </div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{initData.cd_biz_date}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">应收日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{initData.cd_rec_date}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <span class="weui-form-preview__value">{{initData.cd_biz_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据类型</label>
            <span class="weui-form-preview__value">{{initData.cd_biz_name}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">凭证号</label>
            <span class="weui-form-preview__value">{{initData.vb_vocode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">业务员</label>
            <span class="weui-form-preview__value">{{initData.cd_seller}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">币种</label>
            <span class="weui-form-preview__value">{{initData.cd_currency}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">增加应收款（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.cd_rec}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">增加预收款（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.cd_pre}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">应收总额（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.cd_end}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initData: Object
  }
};
</script>